import { QueryCache, QueryClient } from '@tanstack/react-query';
import { isApiError } from './errors';
import { toast } from '@/stores/ui';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (err) => {
      if (!isApiError(err)) return;
      if (err.status === 401) {
        if (!location.pathname.startsWith('/login') && !location.pathname.startsWith('/s/')) {
          const next = encodeURIComponent(location.pathname + location.search);
          location.assign(`/login?next=${next}`);
        }
      } else if (err.status === 403) {
        toast({ kind: 'error', title: "You don't have permission to do that" });
      } else if (err.status === 429) {
        toast({ kind: 'warning', title: `Rate limited — retry in ${err.retryAfter ?? 'a few'} s` });
      } else if (err.status >= 500) {
        toast({ kind: 'error', title: 'Server error', body: err.message });
      }
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      retry: (n, err) => isApiError(err) && err.status >= 500 && n < 2,
    },
  },
});
